const data = Object.freeze({
  PlanningNextSchoolYear: 1,
  AssignStudent: 2,
  DeterioratedMaterialEquipment: 3,
  LostMaterialEquipment: 4,
});
export default data;
